<template>
    <div id="firstStep" class="step">
        <div class="fieldset-content">
            <div class="row">
                <div class="col-12 col-lg-12 col-sm-12">
                    <div class="row formRow">
                        <div class="col-3 col-lg-2 col-sm-4 label control">
                            <label for="state">{{ $t('textTenants.textTittleState') }}</label>
                        </div>
                        <div class="col-9 col-lg-4 col-sm-8 control">
                            <ejs-autocomplete v-model="state" id="state" class="form-control" :dataSource='dataSourceState' :fields='fieldsSourceState' :showPopupButton='true' cssClass="e-outline" :placeholder="$t('textTenants.textFormSelect')" :data-required-message="$t('textTenants.textErrorState')" required="" data-msg-containerid="stateError"></ejs-autocomplete>
                            <div id="stateError"></div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-12 col-sm-12">
                    <div class="row formRow">
                        <div class="col-3 col-lg-2 col-sm-4 label control">
                            <label for="businessName">{{ $t('textTenants.textTittleBusinessName') }}</label>
                        </div>
                        <div class="col-9 col-lg-10 col-sm-8 control">
                            <ejs-textbox v-model="businessName" id="businessName" type="text" class="form-control" :placeholder="$t('textTenants.textFormTypeBusinessName')" :data-required-message="$t('textTenants.textErrorBusinessName')" required="" data-msg-containerid="businessNameError"></ejs-textbox>
                            <div id="businessNameError"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row formGroup">
                <div class="col-12 col-lg-12 col-sm-12">
                    <div class="row formRow">
                        <div class="col-3 col-lg-2 col-sm-4 label control">
                            <label for="email">{{ $t('textTenants.textTittleEmail') }}</label>
                        </div>
                        <div class="col-9 col-lg-4 col-sm-8 control">
                            <ejs-textbox v-model="email" name="email" id="email" type="email" class="form-control" :data-required-message="$t('textTenants.textErrorEmail')" required="" data-msg-containerid="emailError"></ejs-textbox>
                            <div id="emailError"></div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-12 col-sm-12">
                    <div class="row formRow">
                        <div class="col-3 col-lg-2 col-sm-4 label control">
                            <label for="phone">{{ $t('textTenants.textTittlePhone') }}</label>
                        </div>
                        <div class="col-9 col-lg-4 col-sm-8 control">
                            <ejs-textbox v-model="phone" name="Phone" id="phone" type="digit" maxlength="15" min="1" class="form-control" data-msg-containerid="phoneError"></ejs-textbox>
                            <div id="phoneError"></div>
                        </div>
                        <div class="col-3 col-lg-2 col-sm-4 label control">
                            <label for="celphone">{{ $t('textTenants.textTittleCelPhone') }}</label>
                        </div>
                        <div class="col-9 col-lg-4 col-sm-8 control">
                            <ejs-textbox v-model="celphone" name="Celphone" id="celphone" type="tel" maxlength="15" min="1" class="form-control" data-msg-containerid="celphoneError"></ejs-textbox>
                            <div id="celphoneError"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row formGroup">
                <div class="col-12 col-lg-12 col-sm-12">
                    <div class="row formRow">
                        <div class="col-3 col-lg-2 col-sm-4 label control">
                            <label for="country">{{ $t('textTenants.textTittleCountry') }}</label>
                        </div>
                        <div class="col-9 col-lg-4 col-sm-8 control">
                            <ejs-autocomplete id="country" ref='country' v-model="country" :dataSource='dataSourceCountry' :suggestionCount='250' :fields='fieldsCountry' :showPopupButton='true' cssClass="e-outline" :placeholder="$t('textTenants.textFormSelect')" :select='onChangeCountry' autocomplete="off"></ejs-autocomplete>
                        </div>
                        <div class="col-3 col-lg-2 col-sm-4 label control">
                            <label for="departament">{{ $t('textTenants.textTittleDepartament') }}</label>
                        </div>
                        <div class="col-9 col-lg-4 col-sm-8 control">
                            <ejs-autocomplete id="departament" v-model="departament" :dataSource='dataSourceDepartament' :suggestionCount='250' :fields='fieldsSourceDepartament' :showPopupButton='true' cssClass="e-outline" :placeholder="$t('textTenants.textFormSelect')" :select='onChangeDepartament' :query='queryDepartament' :enabled='departamentEnabled' autocomplete="off"></ejs-autocomplete>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-12 col-sm-12">
                    <div class="row formRow">
                        <div class="col-3 col-lg-2 col-sm-4 label control">
                            <label for="municipality">{{ $t('textTenants.textTittleMunicipality') }}</label>
                        </div>
                        <div class="col-9 col-lg-4 col-sm-8 control">
                            <ejs-autocomplete id="municipality" v-model="municipality" :dataSource='dataSourceMunicipality' :suggestionCount='250' :fields='fieldsSourceMunicipality' :showPopupButton='true' cssClass="e-outline" :placeholder="$t('textTenants.textFormSelect')" :query='queryMunicipality' :enabled='municipalityEnabled' :data-required-message="$t('textTenants.textErrorMunicipality')" data-msg-containerid="municipalityError" autocomplete="off"></ejs-autocomplete>
                            <div id="municipalityError"></div>
                        </div>
                        <div class="col-3 col-lg-2 col-sm-4 label control">
                            <label for="address">{{ $t('textTenants.textTittleAddress') }}</label>
                        </div>
                        <div class="col-9 col-lg-4 col-sm-8 control">
                            <input v-model="address" id="address" type="text" class="form-control e-input"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <create-tenant-footer numberPage='1' numberOfPages='3' previousId="previousStep1" nextId="nextStep1" previousDisabled=true></create-tenant-footer>
    </div>
</template>

<script>
import axios from 'axios'
import { Query } from '@syncfusion/ej2-data';
export default {
    name: "create-tenant-first-step",
    data () {
		return {
            formObj: '',
            state : '',
            dataSourceState  : [
                { value: 2, text: "En estructuración"},
                { value: 1, text: "Activo"},
                { value: 0, text: "Inactivo"}
            ],
            fieldsSourceState : { value: 'value', text: 'text' },

            fieldsCountry : { value: 'name' },

            fieldsSourceDepartament : { value: 'name' },
            queryDepartament: null,
            departamentEnabled: false,

            fieldsSourceMunicipality : { value: 'name' },
            queryMunicipality: null,
            municipalityEnabled: false,

            businessName : '',
            email : '',
            phone : '',
            celphone : '',
            address : '',
            country : '',
            departament : '',
            municipality : '',

            dataSourceCountry : [],
            dataSourceDepartament : [],
            dataSourceMunicipality : []
        }
    },
    mounted: function () {
        this.formObj = new FormValidator('#firstStep');
    },
	methods: {
		initEditTenantFirstStep: function(){
			Vue.prototype.$eventHub.$emit('onShowSpinner');
            axios.post('/auth/info/getLocations').then(response => {
				this.dataSourceCountry = response.data.countries.original;
				this.dataSourceDepartament  = response.data.departaments.original;
				this.dataSourceMunicipality = response.data.municipalities.original;
                if(!!this.$route.params.id) {
                    axios.post('/auth/tenants/getInitEditTenantFirstStep', {
                        tenantId: this.$route.params.id,
                    }).then(response => {
                        this.state               = response.data.status;
                        this.businessName        = response.data.razonSocial;
                        this.email               = response.data.email;
                        this.phone               = response.data.telefono;
                        this.celphone            = response.data.celphone;
                        this.address             = response.data.direccion;
                        this.country             = response.data.pais_label;
                        this.departamentEnabled  = true;
                        this.queryDepartament    = new Query().where('countries_id', 'equal', response.data.pais);
                        this.departament         = response.data.departamento_label;
                        this.municipalityEnabled = true;
                        this.queryMunicipality   = new Query().where('departaments_id', 'equal', response.data.departamento);
                        this.municipality        = response.data.municipio_label;
                    });
                }
				Vue.prototype.$eventHub.$emit('onHideSpinner');
            });
        },
        btnClicked: function(args) {
            let formStatus = this.formObj.validate();
            if(formStatus) {
                this.formObj.refresh();
				Vue.prototype.$eventHub.$emit('onChangeTabWizard', args);
            }
        },
		onChangeCountry: function(args){
            this.departament = "";
            this.municipality = "";
            this.queryDepartament = new Query().where('countries_id', 'equal', args.itemData.id);
            this.departamentEnabled = true;
        },
        onChangeDepartament: function(args){
            this.municipality = "";
            this.queryMunicipality = new Query().where('departaments_id', 'equal', args.itemData.id);
            this.municipalityEnabled = true;
        }
    },
    created: function() {
        this.initEditTenantFirstStep();
    }
}
</script>
